import {
  ActionIcon,
  CloseButton,
  Group,
  Loader,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { IconCheck } from "@tabler/icons-react";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { MAX_NAME_STRING } from "../../common/util";
import { EditProps } from "./util";

const TextProp = ({
  className,
  object,
  prop,
  mutate,
  validate,
  label,
  placeholder,
  fullWidth,
  required,
}: EditProps) => {
  const { t } = useTranslation();
  // const objProp = object[prop];
  // let current = (object[prop] as string) || "";
  // if (objProp?._id) current = objProp._id.toString();
  const getVal = (obj: any) => {
    if (!obj) return "";
    let p = obj[prop];
    if (!p) return "";
    if (p._id) p = p._id;
    return p.toString();
  };
  // console.log("current :", current);
  const [saving, setSaving] = useState(false);
  const form = useForm({
    initialValues: {
      value: getVal(object),
    },
    validate: {
      value: (value) => (validate ? validate(value) : null),
    },
  });
  const doSave = (value: string) => {
    // console.log("doSave :", value);
    // object[prop] = value;
    const dto: any = {
      _id: object._id,
    };
    dto[prop] = value;
    setSaving(true);
    mutate(dto, {
      onSuccess: () => {
        form.reset();
        form.setValues({ value });
        setSaving(false);
        showNotification({
          message: t("Saved"),
          autoClose: true,
          color: "success",
        });
      },
    });
  };
  const cancel = () => {
    // console.log("cancel");
    form.reset();
    form.setValues({ value: getVal(object) });
  };
  const edited = form.values.value !== getVal(object);
  const getRightSection = () => {
    if (saving) return <Loader size="xs" />;
    // console.log("form.values.value :", form.values.value);
    const disabled = required && form.values.value.trim() === "";
    if (edited)
      return (
        <Group wrap="nowrap">
          <ActionIcon type="submit" variant="transparent" disabled={disabled}>
            <IconCheck size={16} />
          </ActionIcon>
          <CloseButton onClick={cancel} size="xs" />
        </Group>
      );
  };
  useEffect(() => {
    if (object[prop] === form.values.value) return;
    if (!object[prop]) return;
    form.setValues({ value: getVal(object) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [object]);
  // const onInputSubmit = (e: React.KeyboardEvent<HTMLInputElement>) => {
  //   console.log("onInputSubmit :", value);
  //   if (e.key === "Enter") {
  //     // onSubmit(e);
  //   }
  // };
  return (
    <form
      onSubmit={form.onSubmit((values) => doSave(values.value))}
      className={className}
    >
      <Group>
        <TextInput
          rightSectionWidth={84}
          maxLength={MAX_NAME_STRING}
          placeholder={placeholder || label}
          label={label}
          {...form.getInputProps("value")}
          w={fullWidth ? "100%" : "auto"}
          rightSection={getRightSection()}
        />
      </Group>
    </form>
  );
};
export default TextProp;
